import { ActionReducer, createReducer, on } from '@ngrx/store';
import { InjectionToken } from '@angular/core';
import {
  SharedActions,
  UserActions,
  UserSettingsActions,
} from './user-account-settings.actions';
import { UserModels, UserSettingsModels, UtilsModels } from '@share-models';

export interface UserAccountSettingsState {
  user: UserModels.UserDocument | null;
  isProfileLoaded: boolean;
  error: UtilsModels.StringOrEmpty;
  verifiedPhone: string | null;
  isLoginLoading: boolean;
  userSettings: UserSettingsModels.UserSettingsDocument | null;
  isSaving: boolean;
}

const initialUserState: UserAccountSettingsState = {
  user: null,
  isProfileLoaded: false,
  error: null,
  verifiedPhone: null,
  isLoginLoading: false,
  userSettings: null,
  isSaving: false,
};

export const userAccountSettingsReducer = createReducer(
  initialUserState,
  on(SharedActions.resetToInitialState, () => {
    return {
      ...initialUserState,
    };
  }),

  on(UserActions.loadUserProfileSuccess, (state, action) => {
    return {
      ...state,
      user: action.payload,
      isProfileLoaded: true,
      verifiedPhone: action.payload?.isPhoneVerified
        ? (action.payload.phone ?? null)
        : initialUserState.verifiedPhone,
    };
  }),

  on(UserActions.createOrGetUserProfileFail, (_, action) => {
    return {
      ...initialUserState,
      error: action.message,
    };
  }),

  on(UserActions.updateUserProfileSuccess, (state, action) => {
    return {
      ...state,
      user: action.payload,
    };
  }),

  on(UserActions.updateUserProfileFail, (state, action) => {
    return {
      ...state,
      error: action.message,
    };
  }),
  on(UserActions.setTimezone, (state, { timezone }) => {
    const user = state.user ? { ...state.user, timezone } : null;
    return {
      ...state,
      user,
    };
  }),
  on(UserActions.setPhone, (state, { phone }) => {
    const user = state.user ? { ...state.user, phone } : null;
    return {
      ...state,
      user,
    };
  }),
  on(UserActions.setPhoneVerified, (state, { isPhoneVerified }) => {
    const user = state.user
      ? {
          ...state.user,
          isPhoneVerified,
        }
      : null;
    return {
      ...state,
      user,
    };
  }),
  on(UserActions.setIsLoginLoading, (state, { isLoginLoading }) => {
    return {
      ...state,
      isLoginLoading,
    };
  }),
  on(UserSettingsActions.setUserSettings, (state, { settings }) => {
    const dateFormat = settings.dateFormat ?? 1;
    const hoursFormat = settings.hoursFormat ?? 1;
    return {
      ...state,
      userSettings: {
        ...settings,
        dateFormat,
        hoursFormat,
      },
    };
  }),
  on(UserSettingsActions.updateDevicePageViewSuccess, (state, { settings }) => {
    return {
      ...state,
      userSettings: {
        ...(state.userSettings ?? settings),
        newDevicePageView: settings.newDevicePageView,
      },
    };
  }),
  on(SharedActions.setIsSaving, (state, { isSaving }) => {
    return {
      ...state,
      isSaving,
    };
  }),
);

export const USER_REDUCER = new InjectionToken<
  ActionReducer<UserAccountSettingsState>
>('User Reducer', {
  factory: () => userAccountSettingsReducer,
});
